import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const PremiumUsersChart = () => {
  const data = [
    { date: "Jun 1", value: 12 },
    { date: "Jun 2", value: 3 },
    { date: "Jun 3", value: 6 },
    { date: "Jun 4", value: 2 },
    { date: "Jun 5", value: 16 },
    { date: "Jun 6", value: 18 },
    { date: "Jun 7", value: 15 },
    { date: "Jun 8", value: 20 },
    { date: "Jun 9", value: 20 },
    { date: "Jun 10", value: 19 },
    { date: "Jun 11", value: 20 },
    { date: "Jun 12", value: 21 },
    { date: "Jun 13", value: 22 },
    { date: "Jun 14", value: 21 },
    { date: "Jun 15", value: 22 },
    { date: "Jun 16", value: 20 },
    { date: "Jun 17", value: 12 },
    { date: "Jun 18", value: 10 },
    { date: "Jun 19", value: 2 },
    { date: "Jun 20", value: 20 },
    { date: "Jun 21", value: 10 },
    { date: "Jun 22", value: 20 },
    { date: "Jun 23", value: 2 },
    { date: "Jun 24", value: 9 },
    { date: "Jun 25", value: 12 },
    { date: "Jun 26", value: 2900 },
    { date: "Jun 27", value: 2950 },
    { date: "Jun 28", value: 3000 },
    { date: "Jun 29", value: 3100 },
    { date: "Jun 30", value: 3200 },
  ];

  const calculateChange = (index) => {
    if (index === 0) return null;
    return ((data[index].value - data[index - 1].value) / data[index - 1].value) * 100;
  };

  const options = {
    chart: {
      type: "line",
      backgroundColor: "#fff",
      borderRadius: 8,
      height: 280,
      style: {
        fontFamily: "Arial, sans-serif",
      },
    },
    title: {
      text: "",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#2f4fb5",
      },
    },
    xAxis: {
      categories: data.map((item) => item.date),
      tickInterval: 1,
      lineColor: "#D7E4EB",
      lineWidth: 1,
      tickColor: "#333",
      gridLineColor: "#e6e6e6",
      gridLineDashStyle: "dot",
      gridLineWidth: 1.5,
      labels: {
        style: {
          color: "#6c757d",
          fontSize: 12,
        },
      },
    },
    yAxis: {
      title: {
        text: null,
      },
      labels: {
        formatter: function () {
          const hour = this.value % 24;
          if (hour === 0) return "12 AM";
          if (hour === 4) return "4 AM";
          if (hour === 8) return "8 AM";
          if (hour === 12) return "12 PM";
          if (hour === 16) return "4 PM";
          if (hour === 20) return "8 PM";
          if (hour === 24) return "12 AM";
          return hour;
        },
        style: {
          color: "#6c757d",
          fontSize: 12,
        },
      },
      tickPositions: [0, 4, 8, 12, 16, 20, 24],
      gridLineColor: "#fff",
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        const index = this.points[0].point.index;
        const change = calculateChange(index);
        return `
          <b>${this.points[0].x}</b><br/>
          ₹${this.points[0].y.toFixed(2)}<br/>
          ${
            change !== null
              ? `<span style="color:${change >= 0 ? "green" : "red"}">${change.toFixed(1)}%</span>`
              : ""
          }
        `;
      },
      shared: true,
    },
    series: [
      {
        name: "Revenue",
        data: data.map((item) => item.value),
        color: "#17EB5F",
        marker: {
          enabled: false,
        },
        lineWidth: 1.2,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PremiumUsersChart;
